import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=6117545d&scoped=true&"
import script from "./NewsSection.vue?vue&type=script&lang=js&"
export * from "./NewsSection.vue?vue&type=script&lang=js&"
import style0 from "./NewsSection.vue?vue&type=style&index=0&id=6117545d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117545d",
  null
  
)

export default component.exports